import Chip from "@mui/material/Chip";
import CloseRounded from "@mui/icons-material/CloseRounded";
import { useTranslation } from "react-i18next";
import { PRODUCTS_LIST } from "../../../locales/pages/namespaces";

export default function ClearFiltersChip({ onClick, sx,label }) {
  const { t } = useTranslation(PRODUCTS_LIST);
  return (
    <Chip
      clickable
      onClick={onClick}
      label={label}
      icon={<CloseRounded sx={{ fontSize: 14, color: "#E5007E !important" }} />}
      sx={{
        bgcolor: "#FFFFFF",
        borderRadius: "80px",
        height: 24,
        px: 1.2,
        cursor: "pointer",
        "& .MuiChip-label": {
          color: "#E5007E",
          fontWeight: 900,
          fontFamily: "'Zen Maru Gothic', sans-serif",
          fontSize: 14,
          textTransform: "uppercase",
          letterSpacing: 0.2,
          lineHeight: "120%",
        },
        "& .MuiChip-icon": {
          mr: 0.5,
          color: "#E5007E",
        },
        "&:hover": {
          bgcolor: "#fff5fb",
        },
        ...sx,
      }}
      aria-label={label}
    />
  );
}
